import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { SharedModule } from '@app/shared/shared.module';
import { ButtonComponent } from '@app/shared/components/button/button.component';

@Component({
  selector: 'slotcom-purchase-error-modal',
  templateUrl: './purchase-error.component.html',
  styleUrls: ['./purchase-error.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule],
})
export class PurchaseErrorModalComponent {
  private eventManager = inject(EventManager);
  purchaseErrorModalData = inject<Modal>(MAT_DIALOG_DATA);

  errorCode: number;

  constructor() {
    const purchaseErrorModalData = this.purchaseErrorModalData;

    this.errorCode = purchaseErrorModalData.data.errorCode;
  }

  public closeDialog() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.PurchaseErrorModalComponent, ModalType.View));
  }
}
